<template>
<div class="a-loading">
  <div class="loader">
    <div class="pulse">
      Loading...
    </div>
    <svg>
      <g>
        <circle class="inner" r="5" cx="5" cy="5" />
      </g>
      <g>
        <circle class="inner bounce" r="5" cx="5" cy="5" />
      </g>
      <g>
        <circle class="inner" r="5" cx="5" cy="5" />
      </g>
      <g>
        <circle class="inner bounce" r="5" cx="5" cy="5" />
      </g>
      <g>
        <circle class="inner" r="5" cx="5" cy="5" />
      </g>
      <g>
        <circle class="inner bounce" r="5" cx="5" cy="5" />
      </g>
    </svg>
  </div>
  </div>
</template>
<script>
export default {
	
}
</script>
<style lang="scss" scoped>
.a-loading {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: $red;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
	z-index: 500;
}
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  transition: .3s ease all;
}

.pulse  {
  margin-bottom: 20px;
  animation: 1.5s ease pulse infinite;
  color: #ffffff;
  font-family: 'Amsi Pro', sans-serif;
}

.loader svg {

  position: relative;
  width: 30px;
  height: 30px;
  overflow: visible;
  transform: rotateZ(90deg);

}
.loader svg g {

  mix-blend-mode: screen;
  animation: 3s linear spin infinite;
  transform-origin: center;
  transform-origin: 20px 20px;
}


.loader svg g:nth-child(2) {
  animation-delay: -0.5s;
}
.loader svg g:nth-child(3) {
  animation-delay: -1s;
}
.loader svg g:nth-child(4) {
  animation-delay: -1.5s;
}
.loader svg g:nth-child(5) {
  animation-delay: -2s;
}
.loader svg g:nth-child(6) {
  animation-delay: -2.5s;
}
.loader svg g:nth-child(7) {
  animation-delay: -3s;
}

.loader svg .inner {
  fill: rgba(255,255,255,.3);
  transform-origin: 20px 20px;
}

.loader svg .bounce {
  fill: rgba(255,255,255,.2);
  animation: 1.5s linear pivot infinite;
}


@keyframes spin {
  0% {
    transform: rotateZ(0);
  }
  50% {
    transform: rotateZ(180deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
  
@keyframes pivot {
  0% {
    transform: translate(0px, 0px) rotateZ(60deg);
  }
  100% {
    transform: translate(-41px, 0px) rotateZ(150deg);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}
</style>
